export default "__VITE_PUBLIC_ASSET__597aadf5__"